import { Table } from '@components/shared/Table'
import { useConsolidatedEntry } from '@pages/ConsolidatedEntry/context'
import { parseConsolidatedGrid } from './helpers/parseConsolidatedGrid'

export const ConsolidatedGrid = () => {
  const { isConsolidatedDataLoading } = useConsolidatedEntry()
  const { data, totalData } = parseConsolidatedGrid()

  return <Table data={data} totalData={totalData} isLoading={isConsolidatedDataLoading} />
}
